import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, Typography, Stack, IconButton, Tooltip, Badge } from '@mui/material';
import AppDocuServiceCall from './AppDocuServiceCall';
import { vehicleToString, notifySomething } from './AppDocuCommon';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AssocPacketCalibrationDialog from '../Vehicle_Components/AssocPacketCalibrationDialog';
import AssocDocumentDialog from '../Vehicle_Components/AssocDocumentDialog';
import CalibrationVehicleAssignDialog from './CalibrationVehicleAssignDialog';
import DocumentVehicleAssignDialog from './DocumentVehicleAssignDialog';
import PacketVehicleAssignDialog from './PacketVehicleAssignDialog';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory2';

export default class AssocVechicleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      availableVehicles: [],
      selectedVehicle: null, // Per dialog packets/calibrations
      selectedVehicleForDocs: null, // Per dialog documenti
    };
  }
  
  async componentDidUpdate(prevProps) {
    if (this.props.calibrationId && this.props.calibrationId !== prevProps.calibrationId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getCalibrationVehicles(this.props.calibrationId);
        if (res.data && res.data.is_valid === false) {
          notifySomething(res.data.message || 'Error fetching vehicles', 'error');
          return;
        }
        this.setState({
          availableVehicles: res.data.machines || [],
          loading: false,
        });
      } catch (error) {
        notifySomething('Errore nel caricamento dei dati', 'error');
        this.setState({ loading: false });
      }
    }
  }

  handleOpenPacketsDialog = (vehicle) => {
    // Clona l'oggetto per evitare effetti collaterali
    const selectedVehicle = { ...vehicle, id: vehicle.machine_id };
    this.setState({ selectedVehicle });
  };

  handleClosePacketsDialog = () => {
    this.setState({ selectedVehicle: null });
  };

  handleOpenDocumentsDialog = (vehicle) => {
    const selectedVehicleForDocs = { ...vehicle, id: vehicle.machine_id };
    this.setState({ selectedVehicleForDocs });
  };

  handleCloseDocumentsDialog = () => {
    this.setState({ selectedVehicleForDocs: null });
  };

  render() {
    const { onClose, packetId, calibrationId, documentId } = this.props;
    const { availableVehicles, loading, selectedVehicle } = this.state;
    
    // For calibrations, use the new CalibrationVehicleAssignDialog
    if (calibrationId) {
      return (
        <CalibrationVehicleAssignDialog
          calibrationId={calibrationId}
          onClose={onClose}
          onSave={onClose}
        />
      );
    }
    
    // For documents, use the new DocumentVehicleAssignDialog
    if (documentId) {
      return (
        <DocumentVehicleAssignDialog
          documentId={documentId}
          onClose={onClose}
          onSave={onClose}
        />
      );
    }
    
    // For packets, use the new PacketVehicleAssignDialog
    if (packetId) {
      return (
        <PacketVehicleAssignDialog
          packetId={packetId}
          onClose={onClose}
          onSave={onClose}
        />
      );
    }
    
    // Fallback (should not reach here)
    const open = false;
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Associated Vehicles</DialogTitle>
        <DialogContent>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <List>
              {availableVehicles.length === 0 && <Typography color="text.secondary">No cars associated</Typography>}
              {availableVehicles.map((m, idx) => (
                <ListItem key={m.id ? m.id : idx} disableGutters
                  secondaryAction={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                      <Tooltip title="View Documents">
                        <span>
                          <IconButton size="small" onClick={() => this.handleOpenDocumentsDialog(m)} style={{ marginRight: 0 }}>
                            <Badge
                              badgeContent={m.document_count > 0 ? m.document_count : null}
                              sx={{ '& .MuiBadge-badge': { backgroundColor: '#1976d2', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: 0, top: 2, zIndex: 2 } }}
                              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                              overlap="rectangular"
                            >
                              <DescriptionIcon style={{ color: 'black', fontSize: 20 }} />
                            </Badge>
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="View Packets/Calibrations">
                        <span>
                          <IconButton size="small" onClick={() => this.handleOpenPacketsDialog(m)} style={{ marginRight: 12 }}>
                            <Badge
                              badgeContent={m.package_count > 0 ? m.package_count : null}
                              sx={{ '& .MuiBadge-badge': { backgroundColor: 'orange', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: 0, top: 2, zIndex: 2 } }}
                              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                              overlap="rectangular"
                            >
                              <Badge
                                badgeContent={m.calibration_count > 0 ? m.calibration_count : null}
                                sx={{ '& .MuiBadge-badge': { backgroundColor: 'green', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: -16, top: 2, zIndex: 1 } }}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                overlap="rectangular"
                              >
                                <InventoryIcon style={{ color: 'black', fontSize: 20 }} />
                              </Badge>
                            </Badge>
                          </IconButton>
                        </span>
                      </Tooltip>
                    </span>
                  }
                >
                  <ListItemText
                    primary={vehicleToString(m.machine_id, m)}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
        {/* Dialog per visualizzare packets/calibrations della macchina selezionata */}
        <AssocPacketCalibrationDialog
          vehicleData={selectedVehicle}
          onClose={this.handleClosePacketsDialog}
        />
        {/* Dialog per visualizzare documenti della macchina selezionata */}
        <AssocDocumentDialog
          vehicleData={this.state.selectedVehicleForDocs}
          onClose={this.handleCloseDocumentsDialog}
        />
      </Dialog>
    );
  }
}
